<template>
  <product-infowrap :product="product" :fields="fields" :title="_('General')" :baseDomain="baseDomain" :shopId="shopId" :hideImage="hideImage"></product-infowrap>
</template>

<script>
import ProductInfowrap from '~/components/ProductInfowrap.vue'

export default {
  data () {
    return {
      fields: ['categories', 'location', 'apartmenttype', 'livingarea', 'numberofbeds', 'extrabeds', 'constructionyear', 'renovationyear', 'furtherinformation', 'languages', 'difficulty', 'suitability', 'insurances', 'qualifications', 'website']
    }
  },
  props: ['product', 'baseDomain', 'shopId', 'hideImage'],
  components: {
    ProductInfowrap
  }
}
</script>
